import request from '@/utils/request'

export function page(params) {
  return request({
    url: '/api/base/basePort/page',
    method: 'get',
    params
  })
}

export function add(data) {
  return request({
    url: '/api/base/basePort',
    method: 'post',
    data
  })
}

export function update(data) {
  return request({
    url: '/api/base/basePort',
    method: 'put',
    data
  })
}

export function batchDel(ids) {
  return request({
    url: '/api/base/basePort/batch',
    method: 'delete',
    data: ids
  })
}

export function getById(id) {
  return request({
    url: '/api/base/basePort',
    method: 'get',
    params: {
      id
    }
  })
}
export function listOption(params) {
  return request({
    url: '/api/base/basePort/listOption',
    method: 'get',
    params
  })
}